import { render, staticRenderFns } from "./DropdownBtn.vue?vue&type=template&id=587a2e22&scoped=true&"
import script from "./DropdownBtn.vue?vue&type=script&lang=js&"
export * from "./DropdownBtn.vue?vue&type=script&lang=js&"
import style0 from "./DropdownBtn.vue?vue&type=style&index=0&id=587a2e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a2e22",
  null
  
)

export default component.exports